import axios from '@/utils/axios'
import {business, doctorPrefix, tenantUserPrefix} from '@/api/common'
import {getRoles} from '@/utils/cookie'
import {doctor, tenantUser} from '@/utils/role'

/**
 * 获取所有的穴位配置树形数据
 * @returns {AxiosPromise}
 */
export const loadAllAcupointConfigTreeData = () => {
  let roles = getRoles()
  let url = `${business}${doctorPrefix}/tenant/common/config/loadAcupointConfigTreeData`
  if (roles === tenantUser) {
    url = `${business}${tenantUserPrefix}/tenant/config/loadAcupointConfigTreeData`
  } else if (roles === doctor) {
    url = `${business}${doctorPrefix}/tenant/common/config/loadAcupointConfigTreeData`
  } else {
    return new Promise(resolve => {})
  }
  return axios({
    url: url,
    method: 'get'
  })
}

/**
 * 获取诊所短信基本信息
 * @returns {*}
 */
export const getSmsInfo = () => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/smsInfo`,
    method: 'get'
  })
}

/**
 * 获取诊所短信发送记录
 * @returns {*}
 */
export const getSmsSendRecords = () => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/smsSendRecords`,
    method: 'get'
  })
}

/**
 * 获取诊所短信充值记录
 * @returns {*}
 */
export const getSmsRechargeRecords = () => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/smsRechargeRecords`,
    method: 'get'
  })
}

/**
 * 保存诊所库存配置
 * @param params
 * @returns {*}
 */
export const saveStockConfig = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/stockConfig`,
    method: 'post',
    data: params
  })
}

/**
 * 获取诊所消息配置
 * @returns {*}
 */
export const getMsgConfig = () => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/msgConfig`,
    method: 'get'
  })
}

/**
 * 保存诊所消息配置
 * @param params
 * @returns {*}
 */
export const saveMsgConfig = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/msgConfig`,
    method: 'post',
    data: params
  })
}

/**
 * 保存诊所随访配置
 * @param params
 * @returns {*}
 */
export const saveFollowConfig = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/followConfig`,
    method: 'post',
    data: params
  })
}

/**
 * 诊所查询随访模板列表
 * @returns {*}
 */
export const getFollowTplList = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/followTpls`,
    method: 'post',
    data: params
  })
}

/**
 * 根据ID查询单个随访模板信息
 * @param params
 * @returns {*}
 */
export const getFollowTemplate = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/followTpl`,
    method: 'get',
    params: params
  })
}

/**
 * 诊所保存随访模板
 * @param params
 * @returns {*}
 */
export const saveFollowTpl = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/followTpl`,
    method: 'post',
    data: params
  })
}

/**
 * 诊所删除随访模板
 * @param params
 * @returns {*}
 */
export const removeFollowTpl = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/followTpl/${params}`,
    method: 'post'
  })
}

/**
 * 诊所保存患者标签配置
 * @param form
 * @returns {*}
 */
export const savePatientTagConfig = (form) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/patientTagConfig`,
    method: 'post',
    data: form
  })
}

/**
 * 诊所保存订单配置
 * @param params
 * @returns {*}
 */
export const saveOrderConfig = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/orderConfig`,
    method: 'post',
    data: params
  })
}

/**
 * 查询当前诊所配置
 * @param params
 * @returns {*}
 */
export const getClinicConfig = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/all`,
    method: 'get',
    params: params
  })
}

/**
 * 获取当前诊所费用配置
 * @param params
 * @returns {*}
 */
export const getClinicFeeConfig = (params) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/feeConfig`,
    method: 'get',
    params: params
  })
}

/**
 * 保存当前诊所费用配置
 * @param form
 * @returns {*}
 */
export const saveClinicFeeConfig = (form) => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinicConfig/feeConfig`,
    method: 'post',
    data: form
  })
}

/**
 * 获取费用配置
 * @returns {*}
 */
export const getClinicAllFeeConfig = () => {
  return axios({
    url: `${business}${doctorPrefix}/tenant/clinic/getAllFeeConfig`,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/business/doctor/config/index.js